import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefplan-rolle-controller-entfernen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefplanRolleControllerEntfernenEffects {

    PruefplanRolleControllerEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFPLAN_ROLLE_CONTROLLER_ENTFERNEN),
        mergeMap((x: ac.PostPruefplanRolleControllerEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefplanRolleControllerEntfernen(x.pruefplanRolleRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefplanRolleControllerEntfernenErfolgreichAction(result, x.pruefplanRolleRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefplanRolleControllerEntfernenFehlerAction(error, x.pruefplanRolleRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
